import type { HreflangMap } from "@/src/utils/hreflangs/types"
import { createContext, useContext } from "react"

type AppContextType = {
    /**
     * A map from a locale to the current page's URL for that locale.
     */
    hrefLangs?: HreflangMap
}

/**
 * A provider which acts as a single source of truth for the current's app state.
 */
export const AppProvider = createContext<AppContextType>({
    hrefLangs: undefined
})

/**
 * A hook that allows access to the app context.
 */
export const useAppContext = () => useContext(AppProvider)
